import { Paper, Typography, Grid } from '@mui/material';
import styled from '@emotion/styled';
import { theme } from 'config';

export const Container = styled(Grid)({
  maxWidth: '1152px',
  width: '100%',
  padding: '20px',
  margin: 'auto',
  display: 'flex',
  flexDirection: 'column',

  [theme.breakpoints.down('sm')]: {
    padding: '10px 0',
  },
});

export const HeadWrapper = styled(Grid)({
  display: 'flex',
  alignItems: 'baseline',
  marginTop: '20px',
  marginBottom: '20px',

  [theme.breakpoints.down('sm')]: {
    padding: '0 10px',
  },
});

export const Heading = styled(Typography)({
  marginRight: '10px',
});

export const FlightsCount = styled(Typography)({});

export const Points = styled(Grid)({
  display: 'flex',
  alignItems: 'center',
  marginBottom: '20px',
  flexWrap: 'wrap',

  [theme.breakpoints.down('sm')]: {
    padding: '0 10px',
  },
});

export const Destination = styled(Grid)({
  marginRight: '10px',
  display: 'flex',
  alignItems: 'center',
});

export const Code = styled(Typography)({
  marginLeft: '5px',
});

export const Date = styled(Typography)(
  {
    lineHeight: '18px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
    },
  },
  ({ anywhere }) => ({
    margin: anywhere === 'true' ? 'auto 0 2px' : 'auto 0 6px',
  })
);

export const FilterWrapper = styled(Grid)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexWrap: 'wrap',

  [theme.breakpoints.down('sm')]: {
    padding: '0 10px',
  },
});

export const Description = styled(Typography)({
  fontSize: '13px',
});

export const ListWrapper = styled(Paper)({
  padding: '20px',
  backgroundColor: '#F3F3F3',
  margin: '10px 0',
  borderRadius: '0',

  [theme.breakpoints.down('md')]: {
    padding: '10px',
  },
});
